var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-page"},[_c('div',{staticClass:"img"}),_c('div',{staticClass:"content"},[_c('h1',[_vm._v("404")]),_c('div',{staticClass:"desc"},[_vm._v("抱歉，你访问的页面不存在")])])])
}]

export { render, staticRenderFns }